import React from "react";

const KeyHighlights = (props) => {
  const { keyHighlightsProps } = props;
  return (
    <section className="d-none d-md-flex bg-orange-gradient">
      <div className="container pt-5 position-relative">
        <div className="row">
          <div className="col-md-12 text-center text-white">
            <h2 className="font-w800 mb-3 text-dark">
              {keyHighlightsProps?.question}
            </h2>
            <p className="font-20 font-w300">
              {keyHighlightsProps?.description}
            </p>
          </div>
        </div>
        <div className="row rowCards">
          {keyHighlightsProps?.points?.map((item, index) => (
            <div className="col-md-4 mb-2 mb-md-0" key={index}>
              <div className="text-center p-2">
                <div className="card-body">
                  <img
                    draggable="false"
                    src={item.icon}
                    className="mb-4"
                    alt="Home Icon"
                  />
                  <br />
                  <span className="font-25 font-w700">{item.point}</span>
                  <p className="font-14 mt-3 line-height-20">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyHighlights;
